import { getWeekdayName, toDayOfWeek, toOrdinal } from '../date.js';
import { BaseInstanceRule } from './base-instance-rule.js';
import type { DayOfWeek, LocalDate } from 'src/utilities/local-date.js';
import type { WeekdayStr } from '../weekdayStr';
import { t } from 'src/i18n';

export class MonthlyByNthWeekdayInstanceRule extends BaseInstanceRule {
  // Bygges lazy slik at i18n-`t()` kjøres ved kalltid, ikke ved import.
  private static intervalDescriptions(): string[] {
    return [
      '',
      t('recurrence.intervals.monthly.second'),
      t('recurrence.intervals.monthly.third'),
      t('recurrence.intervals.monthly.fourth'),
      t('recurrence.intervals.monthly.fifth'),
      t('recurrence.intervals.monthly.sixth'),
    ];
  }
  private readonly byWeekDayElement: WeekdayStr;
  private readonly bySetPos: number;
  private readonly dayOfWeek!: DayOfWeek;

  public constructor(byWeekDayElement: WeekdayStr, bySetPos: number) {
    super();
    this.bySetPos = bySetPos;
    this.byWeekDayElement = byWeekDayElement;
    this.dayOfWeek = toDayOfWeek(this.byWeekDayElement);
  }

  public matches(date: LocalDate): boolean {
    if (date.dayOfWeek() === this.dayOfWeek) {
      if (this.bySetPos === -1) {
        const test = date.withLastInMonth(this.dayOfWeek);
        return test.equals(date);
      } else {
        const test = date.withFirstInMonth(this.dayOfWeek).plusWeeks(this.bySetPos - 1);
        return test.equals(date);
      }
    } else {
      return false;
    }
  }

  public optionsToString(interval: number): string {
    return 'FREQ=MONTHLY;INTERVAL=' + interval + ';BYDAY=' + this.byWeekDayElement + ';BYSETPOS=' + this.bySetPos;
  }

  public scheduleDescription(interval: number): string {
    const i = MonthlyByNthWeekdayInstanceRule.intervalDescriptions()[interval - 1];
    return t('recurrence.descriptions.monthlyByNthWeekday', {
      interval: i,
      ordinal: toOrdinal(this.bySetPos),
      weekday: t('events.weekdayDefinite', { weekday: getWeekdayName(this.dayOfWeek) }),
    });
  }
}
